import React, { useState } from "react";
import Joyride, { Step, CallBackProps } from "react-joyride";
import { useTranslation } from "@me8eon/translation";
import "./TourStart.scss";
interface TourGuideProps {
    run: boolean;
    onTourEnd: () => void;
    steps: Step[];
}
const TileTour: React.FC<TourGuideProps> = ({ run, onTourEnd, steps }) => {
    const t = useTranslation();
    const [total, setTotal] = useState<number>(0);
    const [step, setStep] = useState<number>(0);

    const handleJoyrideCallback = (data: CallBackProps) => {
        const { status, size, index, action } = data;
        if (action === "update") {
            setTotal(size);
            setStep(index + 1);
        }
        const finishedStatuses = ["finished", "skipped"];
        if (finishedStatuses.includes(status)) {
            onTourEnd();
        }
    };

    return (
        <div data-testid={run ? "tileTour" : ""}>
            <Joyride
                steps={steps}
                run={run}
                continuous={true}
                scrollToFirstStep={true}
                scrollOffset={80}
                showProgress={true}
                showSkipButton={true}
                callback={handleJoyrideCallback}
                data-testid="tileTour"
                disableOverlayClose={true}
                hideCloseButton={true}
                locale={{
                    back: t("tourData.userActions.back"),
                    close: t("tourData.userActions.close"),
                    last: t("tourData.userActions.last"),
                    nextLabelWithProgress: `${t("tourData.userActions.next")} (${t("tourData.userActions.step")} ${step} ${t("tourData.userActions.of")} ${total})`,
                    open: t("tourData.userActions.open"),
                    skip: t("tourData.userActions.skip"),
                }}
                styles={{
                    options: {
                        arrowColor: "#fff",
                        backgroundColor: "#fff",
                        overlayColor: "rgba(0, 0, 0, 0.4)",
                        primaryColor: "#1ea2b1",
                        textColor: "#262626",
                        width: 300,
                        zIndex: 1005,
                    },
                }}
            />
        </div>
    );
};

export default TileTour;
